import { useState } from "react";
import { Stage, Btn, Modal, Field, Inp, Txta, ExpandTable, BlockHead, Explica } from "../components/primitives";

const STORAGE_KEY = "rc2_claude_design_prompts";

const PROMPTS_BASE = [
  {
    id: "01",
    titulo: "Criar Direção Visual para Cliente",
    descricao: "Gera 4 direções visuais completas: capa de reels, story, post de autoridade, carrossel e CTA premium.",
    texto: `Crie uma fundação visual premium para [Editar aqui com o nome do cliente, exemplo: Dr. Gutemberg Oliveira].

Contexto:
[Editar aqui com o contexto do cliente, exemplo: médico ortopedista especialista em dor crônica e medicina regenerativa.]

A identidade deve transmitir:
- [Editar aqui, exemplo: autoridade]
- [Editar aqui, exemplo: confiança]
- [Editar aqui, exemplo: sofisticação]
- [Editar aqui, exemplo: precisão]
- [Editar aqui, exemplo: acolhimento premium]

Evitar:
- aparência genérica
- excesso visual
- estética popular
- muitos elementos decorativos
- visual de template pronto

Direção visual desejada:
[Editar aqui com cores, estilo e sensação, exemplo: preto premium, dourado sofisticado, branco clínico e visual editorial médico.]

Crie 4 direções visuais diferentes.

Cada direção deve conter:
- capa de reels
- story
- post de autoridade
- carrossel
- CTA premium

O objetivo é criar um sistema visual premium, consistente e flexível para redes sociais.`,
  },
  {
    id: "02",
    titulo: "Criar Brand Book",
    descricao: "Manual visual interno completo: manifesto, paleta, tipografia, regras de composição e assinatura da marca.",
    texto: `Crie um Brand Book visual completo para [Editar aqui com o nome da marca].

A marca representa:
[Editar aqui, exemplo: autoridade clínica, confiança, medicina premium e precisão terapêutica.]

Inclua:
- capa
- manifesto visual
- explicação das direções visuais
- quando usar cada direção
- paleta de cores
- tipografia
- regras de fundo
- regras de fotografia
- composição de posts
- composição de stories
- composição de reels
- composição de carrosséis
- o que fazer
- o que evitar
- assinatura visual da marca

O resultado deve funcionar como manual visual interno da marca.`,
  },
  {
    id: "03",
    titulo: "Criar Direções Editoriais",
    descricao: "4 famílias visuais distintas com reel cover, story, post de autoridade, carrossel e CTA para cada.",
    texto: `Crie 4 direções editoriais completas para [Editar aqui com a marca, exemplo: RC2CLICKS].

A marca deve transmitir:
[Editar aqui, exemplo: inteligência operacional, aquisição estruturada, performance analítica e sofisticação tecnológica.]

Direção 01:
[Editar aqui, exemplo: Operational Editorial — preto dominante, terminal intelligence, Bloomberg, Financial Times.]

Direção 02:
[Editar aqui, exemplo: Clean Intelligence — branco premium, minimalismo, clareza estratégica.]

Direção 03:
[Editar aqui, exemplo: Human Performance — fotografia atmosférica, emoção controlada, profundidade humana.]

Direção 04:
[Editar aqui, exemplo: Strategic Data — grids, indicadores, dashboards e arquitetura analítica.]

Para cada direção criar:
- reel cover
- story
- post de autoridade
- preview de carrossel
- CTA premium

Evitar:
- visual genérico
- excesso visual
- estética motivacional
- aparência de template

Quero que cada direção pareça uma família visual própria.`,
  },
  {
    id: "04",
    titulo: "Criar Capas de Reels",
    descricao: "Coleção de capas 1080x1920 com identidade da marca, leitura mobile e aparência premium.",
    texto: `Crie uma coleção de capas premium para Reels de [Editar aqui com a marca].

Formato:
1080x1920.

Tema da coleção:
[Editar aqui, exemplo: marketing médico com estrutura, autoridade e aquisição.]

Criar:
[Editar aqui, exemplo: 6 capas de reels.]

Títulos:
01 — [Editar aqui]
02 — [Editar aqui]
03 — [Editar aqui]
04 — [Editar aqui]
05 — [Editar aqui]
06 — [Editar aqui]

Manter:
- identidade visual da marca
- leitura rápida no mobile
- contraste forte
- hierarquia clara
- aparência premium
- consistência de coleção

Evitar:
- excesso de informação
- visual genérico
- repetição sem intenção`,
  },
  {
    id: "05",
    titulo: "Criar Stories",
    descricao: "Sistema de 5 stories 1080x1920: impacto, autoridade, bastidor, CTA e pergunta estratégica.",
    texto: `Crie um sistema visual de Stories para [Editar aqui com a marca].

Formato:
1080x1920.

Objetivo:
[Editar aqui, exemplo: criar stories premium para autoridade, conexão e CTA.]

Crie:
1. Story de impacto
2. Story de autoridade
3. Story de bastidor
4. Story CTA premium
5. Story pergunta estratégica

Manter:
- leitura rápida
- pouco texto
- alto contraste
- identidade consistente
- visual premium
- respiro visual

Evitar:
- excesso de texto
- poluição visual
- CTA agressivo
- aparência comum de social media`,
  },
  {
    id: "06",
    titulo: "Criar Carrossel",
    descricao: "Carrossel de 7 slides: capa, contexto, problema, explicação, exemplo, conclusão e CTA.",
    texto: `Crie um carrossel premium para [Editar aqui com a marca].

Formato:
[Editar aqui, exemplo: 1080x1350.]

Tema:
[Editar aqui com o tema.]

Objetivo:
[Editar aqui, exemplo: educar, gerar autoridade e posicionar a marca.]

Estrutura:
Slide 01 — Capa forte
Slide 02 — Contexto
Slide 03 — Problema
Slide 04 — Explicação
Slide 05 — Exemplo
Slide 06 — Conclusão
Slide 07 — CTA premium

Manter:
- identidade visual aprovada
- hierarquia clara
- pouco texto por slide
- aparência editorial
- respiro visual
- leitura fácil no mobile`,
  },
  {
    id: "07",
    titulo: "Criar Post de Autoridade",
    descricao: "Post editorial com headline forte, tom estratégico e visual premium sem excesso.",
    texto: `Crie um post de autoridade para [Editar aqui com a marca].

Formato:
[Editar aqui, exemplo: 1080x1350 ou 1080x1080.]

Tema:
[Editar aqui.]

Headline:
[Editar aqui.]

Tom:
[Editar aqui, exemplo: estratégico, firme, elegante e direto.]

Visual:
[Editar aqui, exemplo: preto editorial, dourado discreto, tipografia premium, poucos elementos.]

Evitar:
- promessa exagerada
- visual genérico
- excesso de texto
- estética agressiva de vendas`,
  },
  {
    id: "08",
    titulo: "Criar Variações de Template",
    descricao: "6 variações de uma mesma peça: escura, clara, com foto, minimalista, com dados e CTA.",
    texto: `Crie variações visuais para este template mantendo a identidade de [Editar aqui com a marca].

Criar:
- versão escura
- versão clara
- versão com fotografia
- versão mais minimalista
- versão com dados
- versão CTA

Manter:
- mesma linguagem visual
- mesma sensação premium
- mesma hierarquia
- mesma assinatura da marca

Variar:
- fundo
- composição
- intensidade
- imagem
- proporção dos elementos
- microdetalhes editoriais`,
  },
  {
    id: "09",
    titulo: "Usar Fotografia",
    descricao: "Integra fotografia como textura, atmosfera ou protagonista mantendo aparência editorial.",
    texto: `Crie uma versão com fotografia para [Editar aqui com a marca].

A imagem deve entrar como:
[Editar aqui, exemplo: textura, profundidade, atmosfera ou protagonista.]

Manter:
- aparência premium
- integração natural da imagem
- tipografia com boa leitura
- contraste forte
- composição editorial

Evitar:
- foto genérica
- aparência de panfleto
- excesso de filtros
- imagem competindo com o texto`,
  },
  {
    id: "10",
    titulo: "Refinar uma Peça",
    descricao: "Ajusta proporção, respiro, hierarquia e sofisticação sem alterar a identidade aprovada.",
    texto: `Refine esta peça mantendo a identidade visual aprovada.

Ajustes:
- reduzir excesso visual
- melhorar proporção
- aumentar respiro
- equilibrar hierarquia
- deixar menos grosseiro
- melhorar leitura no mobile
- tornar mais sofisticado

Não alterar:
- identidade principal
- paleta
- direção visual
- conceito da peça

Objetivo:
mais elegância, mais clareza e mais aparência premium.`,
  },
];

const PROMPTS_DIRECOES = [
  // ── OPERATIONAL EDITORIAL ──────────────────────────────────────────────
  {
    id: "OE-R",
    direcao: "Operational Editorial",
    formato: "Reel",
    titulo: "Reel — Operational Editorial",
    descricao: "Reel vertical 1080×1920. Preto absoluto, JetBrains Mono, dourado editorial, estética Bloomberg Terminal.",
    texto: `REEL — OPERATIONAL EDITORIAL
Crie um Reel premium vertical 1080x1920 seguindo a direção visual "Operational Editorial".

Visual:
- fundo preto absoluto
- grid técnico invisível
- tipografia JetBrains Mono
- dourado editorial discreto
- estética Bloomberg Terminal + Financial Times
- composição vertical rígida
- metadata superior
- footer técnico inferior
- sem aparência de social media comum

Headline principal:
"[Editar aqui com o que quiser]"

Texto secundário:
"[Editar aqui com o que quiser]"

Adicionar:
- micro labels
- códigos operacionais
- linhas hairline douradas
- indicadores analíticos
- respiro visual extremo

Sensação:
inteligência operacional, aquisição estruturada, arquitetura analítica.

Não utilizar:
gradientes fortes, glow, emojis, excesso visual, estética influencer.`,
  },
  {
    id: "OE-S",
    direcao: "Operational Editorial",
    formato: "Story",
    titulo: "Story — Operational Editorial",
    descricao: "Story 1080×1920. Preto editorial, composição minimalista, dashboard estratégico.",
    texto: `STORY — OPERATIONAL EDITORIAL
Crie um Story premium 1080x1920 seguindo a direção visual "Operational Editorial".

Visual:
- preto editorial
- composição minimalista
- tipografia mono técnica
- respiro extremo
- grid invisível
- dourado discreto
- sensação de dashboard estratégico

Headline:
"[Editar aqui com o que quiser]"

Microcopy:
"[Editar aqui com o que quiser]"

Adicionar:
- metadata superior
- footer operacional
- micro linhas
- pequenos indicadores técnicos

Sensação:
sistema operacional premium.`,
  },
  {
    id: "OE-F",
    direcao: "Operational Editorial",
    formato: "Feed",
    titulo: "Feed — Operational Editorial",
    descricao: "Post 1080×1350. Estética Bloomberg, estrutura rígida, blocos analíticos — parece relatório estratégico.",
    texto: `FEED — OPERATIONAL EDITORIAL
Crie um post feed premium 1080x1350 seguindo a direção "Operational Editorial".

Visual:
- estética Bloomberg
- fundo preto
- tipografia JetBrains Mono
- dourado institucional
- estrutura rígida
- grid técnico
- blocos analíticos
- composição editorial

Headline:
"[Editar aqui com o que quiser]"

Texto complementar:
"[Editar aqui com o que quiser]"

Adicionar:
- metadata
- linhas técnicas
- números analíticos
- estrutura institucional

A peça deve parecer:
um relatório estratégico e não um post comum.`,
  },
  {
    id: "OE-C",
    direcao: "Operational Editorial",
    formato: "Carrossel",
    titulo: "Carrossel — Operational Editorial",
    descricao: "4 cards 1080×1350. Diagnóstico → Problema → Insight → Conclusão + CTA. Inteligência estratégica premium.",
    texto: `CARROSSEL — OPERATIONAL EDITORIAL
Crie um carrossel premium 1080x1350 com 4 cards seguindo a direção visual "Operational Editorial".

Visual:
- fundo preto absoluto
- grid invisível
- tipografia JetBrains Mono
- dourado editorial
- aparência institucional
- estrutura modular
- respiro técnico

Tema:
"[Editar aqui com o que quiser]"

Estrutura:

CARD 01:
Headline forte de diagnóstico

CARD 02:
Problema estrutural

CARD 03:
Indicador / dado / insight

CARD 04:
Conclusão operacional + CTA discreto

Adicionar:
- metadata superior
- labels técnicas
- barras analíticas
- códigos operacionais
- indicadores discretos

Sensação:
inteligência estratégica premium.`,
  },

  // ── HUMAN PERFORMANCE ─────────────────────────────────────────────────
  {
    id: "HP-R",
    direcao: "Human Performance",
    formato: "Reel",
    titulo: "Reel — Human Performance",
    descricao: "Reel vertical 1080×1920. Fotografia atmosférica, emoção controlada, profundidade humana sofisticada.",
    texto: `REEL — HUMAN PERFORMANCE
Crie um Reel premium vertical 1080x1920 seguindo a direção visual "Human Performance".

Visual:
- fotografia atmosférica como protagonista
- tons neutros e quentes sofisticados
- tipografia serif ou sans premium
- texto com alto contraste sobre a imagem
- emoção controlada, nunca exagerada
- composição com profundidade e camadas
- metadata discreta
- footer humano

Headline principal:
"[Editar aqui com o que quiser]"

Texto secundário:
"[Editar aqui com o que quiser]"

Adicionar:
- sobreposição sutil de cor
- grão fotográfico discreto
- sombra tipográfica para leitura
- respiro generoso
- hierarquia clara entre imagem e texto

Sensação:
humanidade sofisticada, emoção contida, performance real.

Não utilizar:
filtros exagerados, saturação artificial, estética de banco de imagens, visual motivacional genérico.`,
  },
  {
    id: "HP-S",
    direcao: "Human Performance",
    formato: "Story",
    titulo: "Story — Human Performance",
    descricao: "Story 1080×1920. Fotografia com presença humana, emoção contida, conexão autêntica.",
    texto: `STORY — HUMAN PERFORMANCE
Crie um Story premium 1080x1920 seguindo a direção visual "Human Performance".

Visual:
- fotografia com presença humana
- tom emocional controlado
- tipografia limpa sobre imagem
- contraste alto para leitura mobile
- paleta neutra e quente
- composição respirada

Headline:
"[Editar aqui com o que quiser]"

Microcopy:
"[Editar aqui com o que quiser]"

Adicionar:
- sobreposição de cor suave
- elemento tipográfico de destaque
- detalhe humano autêntico (mãos, olhar, postura)

Sensação:
conexão real, profundidade humana, sofisticação acessível.`,
  },
  {
    id: "HP-F",
    direcao: "Human Performance",
    formato: "Feed",
    titulo: "Feed — Human Performance",
    descricao: "Post 1080×1350. Fotografia atmosférica integrada, hierarquia clara, aparência editorial premium.",
    texto: `FEED — HUMAN PERFORMANCE
Crie um post feed premium 1080x1350 seguindo a direção "Human Performance".

Visual:
- fotografia atmosférica como base
- tipografia premium com leitura clara
- paleta quente e neutra
- composição editorial sofisticada
- sobreposição sutil
- respiro visual equilibrado

Headline:
"[Editar aqui com o que quiser]"

Texto complementar:
"[Editar aqui com o que quiser]"

Adicionar:
- elemento humano autêntico na imagem
- detalhe tipográfico premium
- assinatura discreta da marca

A peça deve parecer:
uma publicação editorial premium, não um post de social media comum.`,
  },
  {
    id: "HP-C",
    direcao: "Human Performance",
    formato: "Carrossel",
    titulo: "Carrossel — Human Performance",
    descricao: "4 cards 1080×1350. Narrativa com elemento humano, progressão emocional, CTA de conexão.",
    texto: `CARROSSEL — HUMAN PERFORMANCE
Crie um carrossel premium 1080x1350 com 4 cards seguindo a direção visual "Human Performance".

Visual:
- fotografia como elemento central em cada card
- paleta consistente de tons neutros e quentes
- tipografia premium com hierarquia clara
- composição respirada e elegante

Tema:
"[Editar aqui com o que quiser]"

Estrutura:

CARD 01:
Abertura com imagem de impacto + headline emocional

CARD 02:
Contexto humano — a situação real

CARD 03:
Transformação ou insight com dado humano

CARD 04:
Conclusão com CTA de conexão

Adicionar:
- progressão visual entre os cards
- elemento humano consistente
- respiro generoso em cada slide

Sensação:
jornada, humanidade, profundidade.`,
  },

  // ── CLEAN INTELLIGENCE ────────────────────────────────────────────────
  {
    id: "CI-R",
    direcao: "Clean Intelligence",
    formato: "Reel",
    titulo: "Reel — Clean Intelligence",
    descricao: "Reel vertical 1080×1920. Branco premium, minimalismo extremo, clareza estratégica.",
    texto: `REEL — CLEAN INTELLIGENCE
Crie um Reel premium vertical 1080x1920 seguindo a direção visual "Clean Intelligence".

Visual:
- fundo branco premium ou off-white
- tipografia sans-serif refinada
- preto profundo para texto principal
- acento em dourado ou cinza estratégico
- composição com espaço em branco generoso
- sem ornamentos desnecessários
- respiro extremo
- hierarquia tipográfica clara

Headline principal:
"[Editar aqui com o que quiser]"

Texto secundário:
"[Editar aqui com o que quiser]"

Adicionar:
- linha fina de separação
- elemento tipográfico de destaque
- micro detalhe elegante
- assinatura mínima

Sensação:
clareza estratégica, inteligência silenciosa, sofisticação sem esforço.

Não utilizar:
excesso de elementos, gradientes, sombras pesadas, aparência genérica de template.`,
  },
  {
    id: "CI-S",
    direcao: "Clean Intelligence",
    formato: "Story",
    titulo: "Story — Clean Intelligence",
    descricao: "Story 1080×1920. Branco editorial, minimalismo, uma ideia por peça.",
    texto: `STORY — CLEAN INTELLIGENCE
Crie um Story premium 1080x1920 seguindo a direção visual "Clean Intelligence".

Visual:
- fundo branco ou off-white premium
- tipografia limpa e precisa
- pouquíssimos elementos
- uma ideia dominante por peça
- linha ou detalhe mínimo como único ornamento

Headline:
"[Editar aqui com o que quiser]"

Microcopy:
"[Editar aqui com o que quiser]"

Adicionar:
- espaço em branco como elemento de design
- detalhe tipográfico de peso contrastante
- assinatura mínima no rodapé

Sensação:
simplicidade radical, inteligência sem ruído.`,
  },
  {
    id: "CI-F",
    direcao: "Clean Intelligence",
    formato: "Feed",
    titulo: "Feed — Clean Intelligence",
    descricao: "Post 1080×1350. Branco dominante, tipografia precisa, clareza total — parece publicação editorial.",
    texto: `FEED — CLEAN INTELLIGENCE
Crie um post feed premium 1080x1350 seguindo a direção "Clean Intelligence".

Visual:
- branco dominante
- tipografia sans-serif precisa
- hierarquia clara: título grande, texto pequeno
- espaço negativo como protagonista
- detalhe mínimo em dourado ou cinza
- zero decoração desnecessária

Headline:
"[Editar aqui com o que quiser]"

Texto complementar:
"[Editar aqui com o que quiser]"

Adicionar:
- linha divisória mínima
- peso tipográfico contrastante
- assinatura discreta

A peça deve parecer:
uma página de publicação internacional premium.`,
  },
  {
    id: "CI-C",
    direcao: "Clean Intelligence",
    formato: "Carrossel",
    titulo: "Carrossel — Clean Intelligence",
    descricao: "4 cards 1080×1350. Um conceito por slide, progressão lógica, elegância sem ruído.",
    texto: `CARROSSEL — CLEAN INTELLIGENCE
Crie um carrossel premium 1080x1350 com 4 cards seguindo a direção visual "Clean Intelligence".

Visual:
- fundo branco premium em todos os cards
- tipografia consistente e precisa
- um conceito dominante por card
- espaço negativo generoso
- detalhes mínimos como divisores

Tema:
"[Editar aqui com o que quiser]"

Estrutura:

CARD 01:
Headline provocativo — uma pergunta ou afirmação

CARD 02:
Contexto mínimo — dado ou observação direta

CARD 03:
Resposta ou reposicionamento claro

CARD 04:
Conclusão + CTA elegante

Adicionar:
- progressão visual limpa
- numeração discreta dos slides
- coerência tipográfica total

Sensação:
raciocínio claro, inteligência sem barulho.`,
  },

  // ── STRATEGIC DATA ────────────────────────────────────────────────────
  {
    id: "SD-R",
    direcao: "Strategic Data",
    formato: "Reel",
    titulo: "Reel — Strategic Data",
    descricao: "Reel vertical 1080×1920. Grids, indicadores, dashboards — dados como design.",
    texto: `REEL — STRATEGIC DATA
Crie um Reel premium vertical 1080x1920 seguindo a direção visual "Strategic Data".

Visual:
- fundo escuro ou preto
- estrutura em grid analítico
- indicadores numéricos como protagonistas
- tipografia mono técnica
- barras, linhas e gráficos minimalistas
- dourado ou azul estratégico como acento
- aparência de dashboard de inteligência

Headline principal:
"[Editar aqui com o que quiser]"

Dado principal:
"[Editar aqui — número, percentual ou métrica]"

Contexto do dado:
"[Editar aqui com o que quiser]"

Adicionar:
- gráfico ou barra analítica
- múltiplos indicadores secundários
- labels técnicas
- metadata de fonte do dado
- estrutura modular de blocos

Sensação:
arquitetura analítica, dados com narrativa, inteligência visual.

Não utilizar:
gráficos de pizza coloridos, visual de apresentação corporativa genérica, excesso decorativo.`,
  },
  {
    id: "SD-S",
    direcao: "Strategic Data",
    formato: "Story",
    titulo: "Story — Strategic Data",
    descricao: "Story 1080×1920. Um dado dominante, contexto mínimo, estrutura de dashboard.",
    texto: `STORY — STRATEGIC DATA
Crie um Story premium 1080x1920 seguindo a direção visual "Strategic Data".

Visual:
- fundo escuro estruturado
- um indicador ou número como elemento central
- tipografia mono ou sans técnica
- blocos analíticos ao redor do dado principal
- acento dourado ou azul estratégico

Dado principal:
"[Editar aqui — número, percentual ou métrica]"

Headline:
"[Editar aqui com o que quiser]"

Microcopy:
"[Editar aqui com o que quiser]"

Adicionar:
- label de fonte do dado
- indicador secundário de contexto
- linha analítica de separação

Sensação:
briefing estratégico em formato visual.`,
  },
  {
    id: "SD-F",
    direcao: "Strategic Data",
    formato: "Feed",
    titulo: "Feed — Strategic Data",
    descricao: "Post 1080×1350. Dado como protagonista, blocos analíticos, aparência de relatório inteligente.",
    texto: `FEED — STRATEGIC DATA
Crie um post feed premium 1080x1350 seguindo a direção "Strategic Data".

Visual:
- estrutura de grid analítico
- dado ou indicador como protagonista visual
- tipografia técnica precisa
- blocos modulares de informação
- fundo escuro com acentos estratégicos
- aparência de relatório de inteligência

Dado principal:
"[Editar aqui — número, percentual ou métrica]"

Headline:
"[Editar aqui com o que quiser]"

Texto complementar:
"[Editar aqui com o que quiser]"

Adicionar:
- gráfico ou indicador visual secundário
- labels analíticas
- fonte do dado
- estrutura modular

A peça deve parecer:
um relatório visual de inteligência, não um infográfico comum.`,
  },
  {
    id: "SD-C",
    direcao: "Strategic Data",
    formato: "Carrossel",
    titulo: "Carrossel — Strategic Data",
    descricao: "4 cards 1080×1350. Narrativa orientada a dados: contexto → problema → dado → decisão.",
    texto: `CARROSSEL — STRATEGIC DATA
Crie um carrossel premium 1080x1350 com 4 cards seguindo a direção visual "Strategic Data".

Visual:
- estrutura analítica consistente em todos os cards
- dado ou indicador como protagonista em cada slide
- fundo escuro com grid modular
- tipografia técnica e precisa
- acento em dourado ou azul estratégico

Tema:
"[Editar aqui com o que quiser]"

Estrutura:

CARD 01:
Dado de impacto + headline de contexto

CARD 02:
Problema quantificado — o que os números mostram

CARD 03:
Insight analítico — o que o dado significa

CARD 04:
Decisão ou ação baseada em dados + CTA direto

Adicionar:
- progressão visual entre os cards
- indicadores crescentes ou comparativos
- labels técnicas consistentes
- fonte dos dados

Sensação:
tomada de decisão baseada em inteligência real.`,
  },
];

function loadCustom() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); } catch { return []; }
}
function saveCustom(list) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
}

/** Lista de prompts: uma linha por prompt, texto completo ao abrir. */
function PromptTable({ prompts, onCopy, copied, custom, onDelete }) {
  return (
    <ExpandTable
      rows={prompts}
      minWidth={520}
      columns={[
        { key: "id", label: "#", render: (p) => <span className="eyebrow">{p.id}</span> },
        { key: "titulo", label: "Prompt", render: (p) => (
          <span>
            <span className="name">{p.titulo}</span>
            {p.descricao && <span className="sub" style={{ display: "block", maxWidth: 560, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.descricao}</span>}
          </span>
        ) },
        { key: "copiar", label: "", align: "right", render: (p) => (
          <span onClick={(e) => e.stopPropagation()} style={{ display: "inline-flex", gap: 6 }}>
            <Btn sm variant={copied === p.id ? "success" : "ghost"} onClick={() => onCopy(p.id, p.texto)}>
              {copied === p.id ? "✓ Copiado" : "Copiar"}
            </Btn>
            {custom && <Btn sm variant="ghost" onClick={() => onDelete(p.id)}>Remover</Btn>}
          </span>
        ) },
      ]}
      detail={(p) => (
        <div className="detail-grid">
          <pre style={{
            margin: 0, background: "var(--surface)", border: "1px solid var(--line)",
            borderRadius: 12, padding: "14px 16px", fontSize: 12.5, color: "var(--muted)", lineHeight: 1.7,
            whiteSpace: "pre-wrap", wordBreak: "break-word", fontFamily: "var(--font-body, inherit)",
            maxHeight: 400, overflowY: "auto",
          }}>
            {p.texto}
          </pre>
          <div className="detail-actions">
            <Btn sm variant="primary" onClick={() => onCopy(p.id, p.texto)}>{copied === p.id ? "✓ Copiado" : "Copiar prompt"}</Btn>
          </div>
        </div>
      )}
    />
  );
}

function NovoPromptModal({ onClose, onSave }) {
  const [titulo, setTitulo] = useState("");
  const [descricao, setDescricao] = useState("");
  const [texto, setTexto] = useState("");

  function salvar() {
    if (!titulo.trim() || !texto.trim()) return;
    onSave({ titulo: titulo.trim(), descricao: descricao.trim(), texto: texto.trim() });
  }

  return (
    <Modal title="Novo prompt" onClose={onClose} width={600}>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <Field label="Título">
          <Inp value={titulo} onChange={(e) => setTitulo(e.target.value)} placeholder="Ex: Criar banner para evento" />
        </Field>
        <Field label="Descrição curta">
          <Inp value={descricao} onChange={(e) => setDescricao(e.target.value)} placeholder="Uma linha descrevendo o objetivo" />
        </Field>
        <Field label="Prompt completo">
          <Txta rows={12} value={texto} onChange={(e) => setTexto(e.target.value)} placeholder="Cole ou escreva o prompt aqui..." />
        </Field>
        <Btn variant="primary" full onClick={salvar} disabled={!titulo.trim() || !texto.trim()}>Salvar prompt</Btn>
      </div>
    </Modal>
  );
}

export function ClaudeDesignView() {
  const [copied, setCopied]   = useState(null);
  const [custom, setCustom]   = useState(loadCustom);
  const [modal, setModal]     = useState(false);

  function handleCopy(id, texto) {
    navigator.clipboard.writeText(texto);
    setCopied(id);
    setTimeout(() => setCopied(null), 2000);
  }

  function addCustom(data) {
    const novo = { ...data, id: `c${Date.now()}`, custom: true };
    const updated = [...custom, novo];
    setCustom(updated);
    saveCustom(updated);
    setModal(false);
  }

  function deleteCustom(id) {
    const updated = custom.filter((p) => p.id !== id);
    setCustom(updated);
    saveCustom(updated);
  }

  const total = PROMPTS_BASE.length + PROMPTS_DIRECOES.length + custom.length;

  return (
    <div className="view" style={{ maxWidth: 1000 }}>

      {/* Palco */}
      <Stage
        path="claude-design"
        title="Claude"
        hl="Design"
        lead={<>{total} prompts prontos para peças visuais no Claude: copie, troque os campos [Editar aqui] e cole.</>}
        actions={<Btn sm variant="primary" onClick={() => setModal(true)}>+ Novo prompt</Btn>}
      />

      {/* O que é e como usar (recolhido) */}
      <div style={{ display: "grid", gap: 8, marginBottom: 8 }}>
        <Explica title="O que é o Claude Design">
          Claude Design é a criação visual nativa do Claude, sem Canva nem Figma. Você descreve o que precisa e o Claude
          gera peças prontas: posts, stories, reels, carrosséis, brand books e sistemas editoriais. Funciona melhor com
          prompts estruturados; os modelos abaixo foram feitos para clientes médicos e para a RC2Clicks.
        </Explica>
        <Explica title="Como usar">
          <ol style={{ margin: 0, paddingLeft: 18, display: "grid", gap: 4 }}>
            <li>Clique no prompt para abrir.</li>
            <li>Identifique os campos [Editar aqui].</li>
            <li>Copie e cole no Claude (claude.ai ou Claude Code).</li>
            <li>Preencha com as informações do cliente ou projeto.</li>
            <li>Envie: o Claude gera as peças.</li>
          </ol>
        </Explica>
      </div>

      <BlockHead title="Base" sub={`${PROMPTS_BASE.length} prompts de fundação`} />
      <PromptTable prompts={PROMPTS_BASE} onCopy={handleCopy} copied={copied} />

      {/* Prompts por direção */}
      {["Operational Editorial", "Human Performance", "Clean Intelligence", "Strategic Data"].map((direcao) => {
        const prompts = PROMPTS_DIRECOES.filter((p) => p.direcao === direcao);
        return (
          <div key={direcao}>
            <BlockHead title={direcao} sub={`${prompts.length} formatos`} />
            <PromptTable prompts={prompts} onCopy={handleCopy} copied={copied} />
          </div>
        );
      })}

      {/* Prompts customizados */}
      {custom.length > 0 && (
        <>
          <BlockHead title="Adicionados por você" sub="Ficam salvos neste navegador." />
          <PromptTable prompts={custom} onCopy={handleCopy} copied={copied} custom onDelete={deleteCustom} />
        </>
      )}

      {modal && <NovoPromptModal onClose={() => setModal(false)} onSave={addCustom} />}
    </div>
  );
}
